var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _vm.profile.country_id
        ? _c("omegaup-countryflag", {
            staticClass: "m-1",
            attrs: { country: _vm.profile.country_id }
          })
        : _vm._e(),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "text-center rounded-circle bottom-margin" }, [
          _c("img", {
            staticClass: "rounded-circle",
            attrs: { src: _vm.profile.gravatar_92 }
          })
        ])
      ]),
      _c("div", { staticClass: "card-title text-center" }, [
        _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("omegaup-user-username", {
              attrs: {
                classname: _vm.profile.classname,
                username: _vm.profile.username
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "mb-3" }, [
          _vm.profile.rankinfo.rank > 0
            ? _c("h4", { staticClass: "m-0" }, [
                _vm._v(" " + _vm._s("#" + _vm.profile.rankinfo.rank) + " ")
              ])
            : _c("small", [
                _c("strong", [_vm._v(" " + _vm._s(_vm.rank) + " ")])
              ]),
          _c("p", [
            _c("small", [_vm._v(" " + _vm._s(_vm.T.profileRank) + " ")])
          ])
        ]),
        _vm.profile.is_own_profile || !_vm.profile.is_private
          ? _c("div", { staticClass: "mb-3" }, [
              _c("h4", { staticClass: "m-0" }, [
                _vm._v(
                  " " + _vm._s(Object.keys(_vm.solvedProblems).length) + " "
                )
              ]),
              _c("p", [
                _c("small", [_vm._v(_vm._s(_vm.T.profileSolvedProblems))])
              ])
            ])
          : _vm._e(),
        _vm.profile.preferred_language &&
        (_vm.profile.is_own_profile || !_vm.profile.is_private)
          ? _c("div", { staticClass: "mb-3" }, [
              _c("h5", { staticClass: "m-0" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.profile.programming_languages[
                        _vm.profile.preferred_language
                      ].split(" ")[0]
                    ) +
                    " "
                )
              ]),
              _c("p", [
                _c("small", [
                  _vm._v(_vm._s(_vm.T.userEditPreferredProgrammingLanguage))
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm.profile.is_own_profile
        ? _c("div", { staticClass: "mb-3 text-center" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-primary btn-sm",
                attrs: { href: _vm.buttonUrl }
              },
              [_vm._v(_vm._s(_vm.buttonText))]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }